import { Action } from 'react-fetching-library';
import { IRestClient, RestClient } from 'services/clients/RestClient';
import { IRequestHeader } from 'services/driverPortal/AuthenticationService.interface';
import { IUpdateExpireDateRequest } from './DriverPortal.interface';
import { IUploadFileResponse } from './Upload.interface';

class NotFound extends Error {}

const baseURL = process.env.REACT_APP_API_BASE_URL || '';
const apiKey = process.env.REACT_APP_DRIVER_PORTAL_API_KEY || '';

export class UploadService {
  private restClient: IRestClient;
  constructor() {
    this.restClient = new RestClient({
      baseURL,
    });
  }

  private buildRequestHeaders(req: IRequestHeader) {
    return {
      'x-api-key': req?.apiKey,
    };
  }

  async getFile(path: string): Promise<string> {
    if (!path) throw new NotFound(`${path} not found`);

    const response = (await this.restClient.request({
      method: 'GET',
      url: `/driver/portal/v1/ondemand/drivers/file${path}`,
      headers: this.buildRequestHeaders({
        apiKey,
      }),
      responseType: 'blob',
    })) as Blob;

    return URL.createObjectURL(response);
  }

  async uploadFile(request: FormData) {
    const path = '/v3/file-service/upload';
    return this.restClient.post<IUploadFileResponse>(path, {
      data: request,
      headers: this.buildRequestHeaders({
        apiKey,
      }),
    });
  }

  updateExpireDateFile = (
    updateExpireDate: IUpdateExpireDateRequest,
  ): Action => {
    const { fileId, expireDate } = updateExpireDate;
    return {
      method: 'PUT',
      endpoint: `/v3/file-service/upload/${fileId}`,
      body: { expireDate },
    };
  };
}
